"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchHierarchy = fetchHierarchy;
exports.importMetadata = importMetadata;
exports.saveHierarchy = saveHierarchy;
var rxjs_1 = require("rxjs");
var moment = require("moment");
var operators_1 = require("rxjs/operators");
var Actions = require("actions/metadataEditorModal");
var ActionTypes = require("actionTypes/metadataEditor");
var Types = require("@caddigital/sok-types");
var errorHandling_1 = require("@caddigital/sok-reducers/lib/utils/errorHandling");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var translate_1 = require("utils/translate");
var connected_react_router_1 = require("connected-react-router");
var toast_1 = require("@caddigital/sok-reducers/lib/actions/toast");
function groupBy(xs, key) {
    return xs.reduce(function (rv, x) {
        ;
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
    }, {});
}
function fetchHierarchy(action$, store, fetchOptions) {
    return action$.ofType(ActionTypes.FETCH_METADATA_EDITOR_HIERARCHY_REQUEST).pipe((0, operators_1.mergeMap)(function (payload) {
        var uuid = payload.uuid, hierarchyType = payload.hierarchyType;
        return fetchOptions
            .ajax({
            headers: {
                'Content-Type': 'application/json',
                Authorization: fetchOptions.getToken()
            },
            method: 'POST',
            url: "".concat(fetchOptions.baseUrl, "api/files/metadata"),
            body: {
                uuids: uuid,
                type: hierarchyType
            }
        })
            .pipe((0, operators_1.flatMap)(function (xhrResponse) {
            var data = xhrResponse.response;
            if (data.list.length === 0) {
                return (0, rxjs_1.of)(Actions.fetchHierarchyFailure({
                    type: 'VALIDATION',
                    errors: ['no files']
                }));
            }
            return (0, rxjs_1.of)(Actions.fetchHierarchySuccess(data));
        }), (0, operators_1.catchError)(function (e) {
            return (0, rxjs_1.of)(Actions.fetchHierarchyFailure((0, errorHandling_1.parseAjaxErrorResponse)(e)));
        }));
    }));
}
var hasExtension = function (filename) {
    var result = /(\.[\w\d]+)$/.exec(filename);
    return result !== null ? true : false;
};
function importMetadata(action$, store, fetchOptions) {
    return action$.ofType(ActionTypes.IMPORT_METADATA_REQUEST).pipe((0, operators_1.mergeMap)(function (payload) {
        var file = payload.file;
        var state = store.value.metadataEditorModal;
        var fr = new FileReader();
        var ext = file.name.split('.').pop();
        if (state.files.length === 0 ||
            file.size === 0 ||
            (ext && ext.toLowerCase() !== 'csv')) {
            return (0, rxjs_1.of)(Actions.importMetadataFailure());
        }
        var customMeta = state.files[0].customMeta;
        if (!customMeta) {
            return (0, rxjs_1.of)(Actions.importMetadataFailure());
        }
        var schema = customMeta
            .filter(function (v) {
            return (v.bitField & Types.CustomMeta.FILES_LIST) > 0 &&
                v.identifier !== 'name-meta' &&
                v.identifier !== 'size-meta' &&
                v.identifier !== 'added-meta' &&
                v.identifier !== 'added-by-meta';
        })
            .map(function (x) { return x.name; });
        var idxLookup = customMeta.reduce(function (prev, x, i) {
            prev[x.identifier] = i;
            return prev;
        }, {});
        var colLookup = customMeta.reduce(function (prev, x, i) {
            prev[x.name] = x.identifier;
            return prev;
        }, {});
        var colTypeLookup = customMeta.reduce(function (prev, x, i) {
            prev[x.identifier] = x.type;
            return prev;
        }, {});
        var nameLookup = state.files.reduce(function (prev, x, i) {
            prev[x.path || x.name] = i;
            if (!prev[x.name]) {
                prev[x.name] = i;
            }
            return prev;
        }, {});
        var observable = rxjs_1.Observable.create(function (observer) {
            return (fr.onload = function () {
                var result = fr.result;
                if (!result) {
                    observer.next(Actions.importMetadataFailure());
                }
                var filesToModify = [];
                var allTextLines = result.split(/\r\n|\n/);
                var headers = allTextLines[0].split(';');
                var csvLookup = {};
                var pathIndex = headers.findIndex(function (h) { return h === 'Path'; });
                var nameIndex = headers.findIndex(function (h) { return h === 'Name'; });
                if (nameIndex < 0) {
                    nameIndex = headers.findIndex(function (h) { return h === 'Nimi'; });
                }
                if (pathIndex < 0) {
                    pathIndex = nameIndex;
                }
                for (var x = 0; x < headers.length; x++) {
                    var header = headers[x];
                    if (schema.indexOf(header) > -1) {
                        csvLookup[x] = header;
                    }
                }
                var hasValidationError = false;
                // Validate the rows against the types of the custom meta fields
                for (var x = 1; x < allTextLines.length; x++) {
                    var cols = allTextLines[x].split(/;(?=(?:(?:[^"]*"){2})*[^"]*$)/);
                    if (!cols) {
                        continue;
                    }
                    cols = cols.map(function (c) { return (c = c.replace(/["']/g, '')); });
                    var path = cols[pathIndex];
                    var name = cols[nameIndex];
                    if (cols.length > headers.length && pathIndex > -1) {
                        var tmpIdx = pathIndex;
                        for (var k = tmpIdx; k < cols.length; k++) {
                            if (cols[k][cols[k].length - 1] === '/' ||
                                hasExtension(cols[k])) {
                                break;
                            }
                            tmpIdx++;
                        }
                        var slice = [];
                        for (var j = pathIndex; j <= tmpIdx; j++) {
                            slice.push(cols[j]);
                        }
                        path = slice.join(';');
                        var tmp1 = [];
                        var tmp2 = [];
                        if (pathIndex > 0) {
                            tmp1 = cols.slice(0, pathIndex);
                        }
                        if (tmpIdx < cols.length) {
                            tmp2 = cols.slice(tmpIdx + 1, cols.length);
                        }
                        cols = tmp1.concat(tmp2);
                        cols.splice(pathIndex, 0, path);
                        if (nameIndex > -1) {
                            tmpIdx = nameIndex;
                            slice = [];
                            for (var k = tmpIdx; k < cols.length; k++) {
                                if (cols[k][cols[k].length - 1] === '/' ||
                                    hasExtension(cols[k])) {
                                    break;
                                }
                                tmpIdx++;
                            }
                            for (var j = nameIndex; j <= tmpIdx; j++) {
                                slice.push(cols[j]);
                            }
                            name = slice.join(';');
                            var tmp1_1 = [];
                            var tmp2_1 = [];
                            if (nameIndex > 0) {
                                tmp1_1 = cols.slice(0, nameIndex);
                            }
                            if (tmpIdx < cols.length) {
                                tmp2_1 = cols.slice(tmpIdx + 1, cols.length);
                            }
                            cols = tmp1_1.concat(tmp2_1);
                            cols.splice(nameIndex, 0, name);
                        }
                    }
                    if (pathIndex === -1) {
                        // since path is missing mapping metadata correctly isn't possible
                        observer.next(Actions.importMetadataFailure());
                        return observer;
                    }
                    var values = {};
                    if (!path.includes('/')) {
                        name = cols[0];
                    }
                    if (name === '') {
                        continue;
                    }
                    var _loop_1 = function (y) {
                        var col = cols[y];
                        var field = csvLookup[y];
                        var colUuid = colLookup[field];
                        var type = colTypeLookup[colUuid];
                        if (!colUuid) {
                            return "continue";
                        }
                        if (field) {
                            // Convert types according to schema
                            if (type === 'checkbox') {
                                values[colUuid] = col === 'true' ? true : false;
                            }
                            else if (type === 'day' || type === 'datetime') {
                                // Ensure that format is correctly formatted iso date
                                if (col !== '') {
                                    // try to parse different formattings of the date to ensure it is any of the supported
                                    var isISO8601 = col.includes('-', 4);
                                    var isFI = col.includes('.');
                                    var isFR = col.includes('/');
                                    if (isISO8601) {
                                        var formattedDate = moment(col, moment.ISO_8601);
                                        var isValid = formattedDate.isValid();
                                        if (!isValid) {
                                            hasValidationError = true;
                                        }
                                        values[colUuid] = isValid
                                            ? formattedDate.unix() * 1000
                                            : null;
                                    }
                                    else if (isFI) {
                                        var formattedDate = moment(col, 'DD.MM.YYYY');
                                        var isValid = formattedDate.isValid();
                                        if (!isValid) {
                                            hasValidationError = true;
                                        }
                                        values[colUuid] = isValid
                                            ? formattedDate.unix() * 1000
                                            : null;
                                    }
                                    else if (isFR) {
                                        var formattedDate = moment(col, 'DD/MM/YYYY');
                                        var isValid = formattedDate.isValid();
                                        if (!isValid) {
                                            hasValidationError = true;
                                        }
                                        values[colUuid] = isValid
                                            ? formattedDate.unix() * 1000
                                            : null;
                                    }
                                    else {
                                        values[colUuid] = null;
                                        hasValidationError = true;
                                    }
                                }
                                else {
                                    values[colUuid] = null;
                                }
                            }
                            else if (type === 'select' ||
                                type === 'dependant-select') {
                                // Ensure that selected value is acceptable
                                var selectSchema = customMeta[idxLookup[colUuid]];
                                if (selectSchema) {
                                    var options = selectSchema.options;
                                    if (options.filter(function (x) {
                                        return x.name.toLowerCase() === col.toLowerCase();
                                    }).length > 0) {
                                        values[colUuid] = options.find(function (x) {
                                            return x.name.toLowerCase() === col.toLowerCase();
                                        }).value;
                                        return "continue";
                                    }
                                    else if (col !== '') {
                                        hasValidationError = true;
                                    }
                                }
                                values[colUuid] = null;
                            }
                            else {
                                values[colUuid] = col !== '' ? col : null;
                            }
                        }
                    };
                    for (var y = 0; y < cols.length; y++) {
                        _loop_1(y);
                    }
                    // Check that path exists and override values
                    var fileIndex = nameLookup[path];
                    // workaround to fix the metaexport hokalointi "fixes" =)
                    if ((fileIndex === null || fileIndex === undefined) &&
                        path.charAt(0) !== '/') {
                        fileIndex = nameLookup['/' + path];
                    }
                    if (fileIndex === null ||
                        (fileIndex === undefined && path.charAt(0) === '/')) {
                        fileIndex = nameLookup[path.slice(1, path.length)];
                    }
                    if (fileIndex !== null && fileIndex !== undefined) {
                        var fileToModify = state.files[fileIndex];
                        if (fileToModify) {
                            filesToModify.push({ uuid: fileToModify.uuid, values: values });
                        }
                        else {
                            hasValidationError = true;
                        }
                    }
                    else {
                        hasValidationError = true;
                    }
                }
                observer.next(Actions.batchEditMetadataRow(filesToModify));
                observer.next(Actions.importMetadataSuccess(!hasValidationError));
            });
        });
        fr.readAsText(file);
        return observable;
    }));
}
function saveHierarchy(action$, store, fetchOptions) {
    return action$.ofType(ActionTypes.SAVE_METADATA_EDITOR_REQUEST).pipe((0, operators_1.mergeMap)(function (payload) {
        var hierarchyType = payload.hierarchyType;
        var state = store.value.metadataEditorModal;
        var metas = state.dirtyColumns;
        var errRows = {};
        var failedColumnsMap = {};
        var errorRows = [];
        state.files.forEach(function (row, idx) {
            var hasError = false;
            if (row.type === 'FOLDER') {
                return;
            }
            row.customMeta.forEach(function (col, idx) {
                if (state.requiredCols[col.identifier] === true) {
                    if (col.value === null || col.value === '') {
                        if (!errRows[row.uuid]) {
                            errRows[row.uuid] = {};
                        }
                        errRows[row.uuid][col.identifier] = true;
                        col.hasError = true;
                        failedColumnsMap[col.identifier] = true;
                        hasError = true;
                    }
                }
            });
            if (hasError) {
                errorRows.push(idx);
            }
        });
        var failedColumns = Object.keys(failedColumnsMap);
        if (failedColumns.length > 0) {
            return (0, rxjs_1.of)(Actions.validateMetadataFormFailure(failedColumns, errorRows, errRows));
        }
        var groupedByRow = groupBy(metas, 'row');
        var keys = Object.keys(groupedByRow);
        var groups = keys.reduce(function (map, uuid) {
            var val = groupedByRow[uuid].reduce(function (acc, val) {
                acc[val.identifier] = val.value;
                return acc;
            }, {});
            map[uuid] = val;
            return map;
        }, {});
        return (0, rxjs_1.merge)((0, rxjs_1.of)(Actions.validateMetadataFormSuccess()), fetchOptions
            .ajax({
            headers: {
                'Content-Type': 'application/json',
                Authorization: fetchOptions.getToken()
            },
            method: 'POST',
            url: "".concat(fetchOptions.baseUrl, "api/files/metadata/save"),
            body: __assign(__assign({}, payload), { metas: groups })
        })
            .pipe((0, operators_1.flatMap)(function () {
            if (payload &&
                payload.hierarchyType === 'SESSION' &&
                payload.publish === true) {
                var _a = store.value, files = _a.files, project = _a.project, metadataEditorModal = _a.metadataEditorModal;
                var language = (0, translate_1.getLanguage)();
                if (project.currentProject.status === 'FETCHED') {
                    if (files.currentFolder !== null) {
                        return (0, rxjs_1.merge)((0, rxjs_1.of)((0, toast_1.addNewToast)((0, translation_1.getLocalization)('toast/new_file_added'), (0, translation_1.getLocalization)('toast/new_files_uploaded'), 'NORMAL', [])), (0, rxjs_1.of)((0, connected_react_router_1.goBack)()).pipe((0, operators_1.delay)(2000)));
                    }
                    else {
                        return (0, rxjs_1.merge)((0, rxjs_1.of)((0, toast_1.addNewToast)((0, translation_1.getLocalization)('toast/new_file_added'), (0, translation_1.getLocalization)('toast/new_files_uploaded'), 'NORMAL', [])), (0, rxjs_1.of)((0, connected_react_router_1.goBack)()).pipe((0, operators_1.delay)(2000)));
                    }
                }
            }
            return (0, rxjs_1.of)(Actions.saveMetadataFormSuccess());
        }), (0, operators_1.catchError)(function (e) {
            return (0, rxjs_1.of)(Actions.saveMetadataFormFailure((0, errorHandling_1.parseAjaxErrorResponse)(e)));
        })));
    }));
}
